import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_CUSAT } from 'constants/api';
import { storeName } from '../config';
import { CusatDataItem, CusatDataPayload } from '../interfaces';

export const createCusat = createAsyncThunk<CusatDataItem, CusatDataPayload>(
  `${storeName}/create`,
  async (payload, thunkAPI) =>
    api.axios
      .post(API_CUSAT, payload)
      .then((res) => res.data)
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
